// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","LoadingPlaceholderParent":"bch_a bhn_wl","LoadingPlaceholder":"bch_b bhn_h","loading-placeholder":"bch_c"};